import React, { Component, useRef } from "react";
import Delete from "../../../../Assets/img/svg/delete.svg";
import del from "../../../../Assets/img/svg/Del.svg";
import View from "../../../../Assets/img/svg/view.svg";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.min.js";
import "jquery-ui-dist/jquery-ui.min.css";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../Assets/jss/customStyle";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import axios from "axios";
import API from "../../../../helpers/endpointService";
import EasyEdit from "react-easy-edit";
import Save from "../../../../Assets/img/svg/save.svg";
import Cancel from "../../../../Assets/img/svg/cancel.svg";
import active from "../../../../Assets/img/svg/active.svg";
import deactive from "../../../../Assets/img/svg/deactive.svg";
import {warningAlert,successAlert} from "../../../custom/alert"
import {
  Radio,
  RadioGroup,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@material-ui/core";
import upload from "../../../../Assets/img/svg/upload.svg";
import { CssTextField } from "../../../custom/textField";
import { inspectionSystem } from "../../../Constants";
import { INSPECT_MAX_BYTES } from "buffer";
import { successToast, errorToast } from "../../../../actions/CommonFunction";

class AddEditGD extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      Gradingdata: [],
      Vesseldata: [],
      isMobile: false,
      isView: false,
      GetManagementResult: [],
      conditionData: {
        "Id": 0,
        "ShipId": 0,
        "SectionId": inspectionSystem.GradingData,
        "InspectionId": 0,
        "DesignAndConstruction": 0,
        "Hull": 0,
        "FocsleAndPoopDeck": 0,
        "MaindeckAndFittings": 0,
        "BallastTanksAndVoidSpaces": 0,
        "GalleyAndAccomodation": 0,
        "EngineRoom": 0,
        "FireAndSafety": 0,
        "LifesavingEquipment": 0,
        "SafeWorking": 0,
        "NavigationBridgeAndCommunication": 0,
        "PollutionControl": 0,
        "OnboardManagement": 0,
        "CargoSystems": 0,
        "CreatedBy": "",
        "ModifiedBy": "",
      },
      managementData: {
        "Id": 0,
        "ShipId": 0,
        "SectionId": inspectionSystem.GradingData,
        "InspectionId": 0,
        "ForthcomingRegulatoryCompliance": 0,
        "CrewWelfare": 0,
        "CrewPerformance": 0,
        "HseqSystems": 0,
        "ManagementSystems": 0,
        "ClassificationAndCertification": 0,
        "VettingOrPscperformanceOrRecords": 0,
        "CreatedBy": "",
        "ModifiedBy": "",
      }
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    await this.setgratingdata();
    await this.setvesseldata();
    localStorage.getItem("UserRoles") == "Admin" ||
      localStorage.getItem("UserRoles") == "Supervisor"
      ? this.setState({ isView: true })
      : this.setState({ isView: false });
    this.state.managementData.ShipId = parseInt(localStorage.getItem("DashId"));
    this.state.managementData.InspectionId = parseInt(localStorage.getItem("InspectionId"));
    this.state.conditionData.ShipId = parseInt(localStorage.getItem("DashId"));
    this.state.conditionData.InspectionId = parseInt(localStorage.getItem("InspectionId"));
    this.setState({});
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
    this.GetGradingdata(inspectionSystem.GradingData)
  }
  setRedSliderValue = (Id, value) => {
    if (parseInt(value) === 0) {
      $("#gradingcolor1" + Id).removeClass("active-color");
      $("#gradingcolor2" + Id).removeClass("active-color1");
      $("#gradingcolor3" + Id).removeClass("active-color2");
      $("#gradingcolor4" + Id).removeClass("active-color3");
      $("#gradingcolor5" + Id).removeClass("active-color4");
      $("#gradingcolor6" + Id).removeClass("active-color5");
      $("#gradingcolor7" + Id).removeClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 10) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).removeClass("active-color1");
      $("#gradingcolor3" + Id).removeClass("active-color2");
      $("#gradingcolor4" + Id).removeClass("active-color3");
      $("#gradingcolor5" + Id).removeClass("active-color4");
      $("#gradingcolor6" + Id).removeClass("active-color5");
      $("#gradingcolor7" + Id).removeClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 20) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).removeClass("active-color2");
      $("#gradingcolor4" + Id).removeClass("active-color3");
      $("#gradingcolor5" + Id).removeClass("active-color4");
      $("#gradingcolor6" + Id).removeClass("active-color5");
      $("#gradingcolor7" + Id).removeClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 30) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).removeClass("active-color3");
      $("#gradingcolor5" + Id).removeClass("active-color4");
      $("#gradingcolor6" + Id).removeClass("active-color5");
      $("#gradingcolor7" + Id).removeClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 40) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).addClass("active-color3");
      $("#gradingcolor5" + Id).removeClass("active-color4");
      $("#gradingcolor6" + Id).removeClass("active-color5");
      $("#gradingcolor7" + Id).removeClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 50) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).addClass("active-color3");
      $("#gradingcolor5" + Id).addClass("active-color4");
      $("#gradingcolor6" + Id).removeClass("active-color5");
      $("#gradingcolor7" + Id).removeClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 60) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).addClass("active-color3");
      $("#gradingcolor5" + Id).addClass("active-color4");
      $("#gradingcolor6" + Id).addClass("active-color5");
      $("#gradingcolor7" + Id).removeClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 70) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).addClass("active-color3");
      $("#gradingcolor5" + Id).addClass("active-color4");
      $("#gradingcolor6" + Id).addClass("active-color5");
      $("#gradingcolor7" + Id).addClass("active-color6");
      $("#gradingcolor8" + Id).removeClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 80) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).addClass("active-color3");
      $("#gradingcolor5" + Id).addClass("active-color4");
      $("#gradingcolor6" + Id).addClass("active-color5");
      $("#gradingcolor7" + Id).addClass("active-color6");
      $("#gradingcolor8" + Id).addClass("active-color7");
      $("#gradingcolor9" + Id).removeClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 90) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).addClass("active-color3");
      $("#gradingcolor5" + Id).addClass("active-color4");
      $("#gradingcolor6" + Id).addClass("active-color5");
      $("#gradingcolor7" + Id).addClass("active-color6");
      $("#gradingcolor8" + Id).addClass("active-color7");
      $("#gradingcolor9" + Id).addClass("active-color8");
      $("#gradingcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 100) {
      $("#gradingcolor1" + Id).addClass("active-color");
      $("#gradingcolor2" + Id).addClass("active-color1");
      $("#gradingcolor3" + Id).addClass("active-color2");
      $("#gradingcolor4" + Id).addClass("active-color3");
      $("#gradingcolor5" + Id).addClass("active-color4");
      $("#gradingcolor6" + Id).addClass("active-color5");
      $("#gradingcolor7" + Id).addClass("active-color6");
      $("#gradingcolor8" + Id).addClass("active-color7");
      $("#gradingcolor9" + Id).addClass("active-color8");
      $("#gradingcolor10" + Id).addClass("active-color9");
    }
  }
  setVesselSliderValue = (Id, value) => {
    if (parseInt(value) === 0) {
      $("#vesselcolor1" + Id).removeClass("active-color");
      $("#vesselcolor2" + Id).removeClass("active-color1");
      $("#vesselcolor3" + Id).removeClass("active-color2");
      $("#vesselcolor4" + Id).removeClass("active-color3");
      $("#vesselcolor5" + Id).removeClass("active-color4");
      $("#vesselcolor6" + Id).removeClass("active-color5");
      $("#vesselcolor7" + Id).removeClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 10) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).removeClass("active-color1");
      $("#vesselcolor3" + Id).removeClass("active-color2");
      $("#vesselcolor4" + Id).removeClass("active-color3");
      $("#vesselcolor5" + Id).removeClass("active-color4");
      $("#vesselcolor6" + Id).removeClass("active-color5");
      $("#vesselcolor7" + Id).removeClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 20) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).removeClass("active-color2");
      $("#vesselcolor4" + Id).removeClass("active-color3");
      $("#vesselcolor5" + Id).removeClass("active-color4");
      $("#vesselcolor6" + Id).removeClass("active-color5");
      $("#vesselcolor7" + Id).removeClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 30) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).removeClass("active-color3");
      $("#vesselcolor5" + Id).removeClass("active-color4");
      $("#vesselcolor6" + Id).removeClass("active-color5");
      $("#vesselcolor7" + Id).removeClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 40) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).addClass("active-color3");
      $("#vesselcolor5" + Id).removeClass("active-color4");
      $("#vesselcolor6" + Id).removeClass("active-color5");
      $("#vesselcolor7" + Id).removeClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 50) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).addClass("active-color3");
      $("#vesselcolor5" + Id).addClass("active-color4");
      $("#vesselcolor6" + Id).removeClass("active-color5");
      $("#vesselcolor7" + Id).removeClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 60) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).addClass("active-color3");
      $("#vesselcolor5" + Id).addClass("active-color4");
      $("#vesselcolor6" + Id).addClass("active-color5");
      $("#vesselcolor7" + Id).removeClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 70) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).addClass("active-color3");
      $("#vesselcolor5" + Id).addClass("active-color4");
      $("#vesselcolor6" + Id).addClass("active-color5");
      $("#vesselcolor7" + Id).addClass("active-color6");
      $("#vesselcolor8" + Id).removeClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 80) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).addClass("active-color3");
      $("#vesselcolor5" + Id).addClass("active-color4");
      $("#vesselcolor6" + Id).addClass("active-color5");
      $("#vesselcolor7" + Id).addClass("active-color6");
      $("#vesselcolor8" + Id).addClass("active-color7");
      $("#vesselcolor9" + Id).removeClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 90) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).addClass("active-color3");
      $("#vesselcolor5" + Id).addClass("active-color4");
      $("#vesselcolor6" + Id).addClass("active-color5");
      $("#vesselcolor7" + Id).addClass("active-color6");
      $("#vesselcolor8" + Id).addClass("active-color7");
      $("#vesselcolor9" + Id).addClass("active-color8");
      $("#vesselcolor10" + Id).removeClass("active-color9");
    } else if (parseInt(value) <= 100) {
      $("#vesselcolor1" + Id).addClass("active-color");
      $("#vesselcolor2" + Id).addClass("active-color1");
      $("#vesselcolor3" + Id).addClass("active-color2");
      $("#vesselcolor4" + Id).addClass("active-color3");
      $("#vesselcolor5" + Id).addClass("active-color4");
      $("#vesselcolor6" + Id).addClass("active-color5");
      $("#vesselcolor7" + Id).addClass("active-color6");
      $("#vesselcolor8" + Id).addClass("active-color7");
      $("#vesselcolor9" + Id).addClass("active-color8");
      $("#vesselcolor10" + Id).addClass("active-color9");
    }
  }

  setConditionSliderValue = () => {
    $(".sliderDivClass" + 1).slider("value", this.state.conditionData.DesignAndConstruction);
    $(".sliderDivClass" + 2).slider("value", this.state.conditionData.Hull);
    $(".sliderDivClass" + 3).slider("value", this.state.conditionData.FocsleAndPoopDeck);
    $(".sliderDivClass" + 4).slider("value", this.state.conditionData.MaindeckAndFittings);
    $(".sliderDivClass" + 5).slider("value", this.state.conditionData.BallastTanksAndVoidSpaces);
    $(".sliderDivClass" + 6).slider("value", this.state.conditionData.GalleyAndAccomodation);
    $(".sliderDivClass" + 7).slider("value", this.state.conditionData.EngineRoom);
    $(".sliderDivClass" + 8).slider("value", this.state.conditionData.FireAndSafety);
    $(".sliderDivClass" + 9).slider("value", this.state.conditionData.LifesavingEquipment);
    $(".sliderDivClass" + 10).slider("value", this.state.conditionData.SafeWorking);
    $(".sliderDivClass" + 11).slider("value", this.state.conditionData.NavigationBridgeAndCommunication);
    $(".sliderDivClass" + 12).slider("value", this.state.conditionData.PollutionControl);
    $(".sliderDivClass" + 13).slider("value", this.state.conditionData.OnboardManagement);
    $(".sliderDivClass" + 14).slider("value", this.state.conditionData.CargoSystems);
  }
  setManagementSliderValue = () => {
    $(".vesselsliderDivClass" + 1).slider("value", this.state.managementData.ForthcomingRegulatoryCompliance);
    $(".vesselsliderDivClass" + 2).slider("value", this.state.managementData.CrewWelfare);
    $(".vesselsliderDivClass" + 3).slider("value", this.state.managementData.CrewPerformance);
    $(".vesselsliderDivClass" + 4).slider("value", this.state.managementData.HseqSystems);
    $(".vesselsliderDivClass" + 5).slider("value", this.state.managementData.ManagementSystems);
    $(".vesselsliderDivClass" + 6).slider("value", this.state.managementData.ClassificationAndCertification);
    $(".vesselsliderDivClass" + 7).slider("value", this.state.managementData.VettingOrPscperformanceOrRecords);
  }
  setvesseldata = () => {
    this.setState({
      Vesseldata: [
        {
          Id: 1,
          title: "Forthcoming Regulatory Compliance",
        },
        {
          Id: 2,
          title: "Crew Welfare",
        },
        {
          Id: 3,
          title: "Crew Performance",
        },
        {
          Id: 4,
          title: "HSEQ Systems",
        },
        {
          Id: 5,
          title: "Management Systems (ISM / PMS)",
        },
        {
          Id: 6,
          title: "Classification & Certification",
        },
        {
          Id: 7,
          title: "Vetting / PSC Performance / Records",
        },
      ],
    });
  };

  setgratingdata = () => {
    this.setState({
      Gradingdata: [
        {
          Id: 1,
          title: "Design & Construction",
        },
        {
          Id: 2,
          title: "Hull",
        },
        {
          Id: 3,
          title: "Foc'sle & Poop Deck",
        },
        {
          Id: 4,
          title: "Maindeck & Fittings",
        },
        {
          Id: 5,
          title: "Ballast Tanks & Void Spaces",
        },
        {
          Id: 6,
          title: "Galley & Accomodation",
        },
        {
          Id: 7,
          title: "Engine Room, Machinery & Machinery Spaces",
        },
        {
          Id: 8,
          title: "Fire Fighting Appliances",
        },
        {
          Id: 9,
          title: "Lifesaving Equipment",
        },
        {
          Id: 10,
          title: "Safe Working",
        },
        {
          Id: 11,
          title: "Navigation Bridge & Communication",
        },
        {
          Id: 12,
          title: "Pollution Control",
        },
        {
          Id: 13,
          title: "Onboard Management and Crew Motivation",
        },
        {
          Id: 14,
          title: "Cargo Systems",
        },
      ],
    });
  };

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("resize", this.resize.bind(this));
    $("#GRAD1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#GradingData1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#GradingData").addClass("d-none");
    $("#GradingData").removeClass("d-block");
    $("#GDL").removeClass("active-color");
    $("#GDT").removeClass("fw-bolder");
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  }
  resize1 = () => {
    $("#GRAD1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#GradingData1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#GradingData").removeClass("d-none");
    $("#GradingData").addClass("d-block");
    $("#GDL").addClass("active-color");
    $("#GDT").addClass("fw-bolder");
  }
  sidebar = () => {
    this.props.navigate("/sidebar");
  };

  OpenPopup = () => {
    window.$("#deletepopup").modal("show");
  };
  GetGradingdata = (Id) => {
    const { dispatch } = this.props;
    let Ship = parseInt(localStorage.getItem("DashId"));
    let inspection = parseInt(localStorage.getItem("InspectionId"));
    let apiUrl = `${API.Get_Grading}?ShipId=${Ship}&InspectionId=${inspection}&SectionId=${Id}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios.get(apiUrl)
      .then((response) => {
        if (response?.status === 200) {
          console.log(response.data)
          if (response?.data.Condition !== null && response?.data.Management !== null) {
            this.state.conditionData = response?.data?.Condition;
            this.state.managementData = response?.data?.Management;
            this.setState({})
          }
          this.state.Gradingdata.map((i) => {
            let _this = this;
            $(document).ready(function () {
              $(".sliderDivClass" + i.Id).slider({
                orientation: "horizontal",
                range: "min",
                min: 0,
                max: 100,
                step: 1,
                value: 0,
                slide: function (event, ui) {
                  $("#redSliderInputId" + i.Id).val(ui.value);
                  _this.setRedSliderValue(i.Id, ui.value);
                }
              });
              _this.setConditionSliderValue();
            });
          });
          this.state.Gradingdata.map((j) => {
            $(document).ready(function () {
              $("#redSliderInputId" + j.Id).val($(".sliderDivClass" + j.Id).slider("value"));
              var value = $('#redSliderInputId' + j.Id).val();
              console.log("values", value)
              if (parseInt(value) === 0) {
                $("#gradingcolor1" + j.Id).removeClass("active-color");
                $("#gradingcolor2" + j.Id).removeClass("active-color1");
                $("#gradingcolor3" + j.Id).removeClass("active-color2");
                $("#gradingcolor4" + j.Id).removeClass("active-color3");
                $("#gradingcolor5" + j.Id).removeClass("active-color4");
                $("#gradingcolor6" + j.Id).removeClass("active-color5");
                $("#gradingcolor7" + j.Id).removeClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 10) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).removeClass("active-color1");
                $("#gradingcolor3" + j.Id).removeClass("active-color2");
                $("#gradingcolor4" + j.Id).removeClass("active-color3");
                $("#gradingcolor5" + j.Id).removeClass("active-color4");
                $("#gradingcolor6" + j.Id).removeClass("active-color5");
                $("#gradingcolor7" + j.Id).removeClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 20) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).removeClass("active-color2");
                $("#gradingcolor4" + j.Id).removeClass("active-color3");
                $("#gradingcolor5" + j.Id).removeClass("active-color4");
                $("#gradingcolor6" + j.Id).removeClass("active-color5");
                $("#gradingcolor7" + j.Id).removeClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 30) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).removeClass("active-color3");
                $("#gradingcolor5" + j.Id).removeClass("active-color4");
                $("#gradingcolor6" + j.Id).removeClass("active-color5");
                $("#gradingcolor7" + j.Id).removeClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 40) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).addClass("active-color3");
                $("#gradingcolor5" + j.Id).removeClass("active-color4");
                $("#gradingcolor6" + j.Id).removeClass("active-color5");
                $("#gradingcolor7" + j.Id).removeClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 50) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).addClass("active-color3");
                $("#gradingcolor5" + j.Id).addClass("active-color4");
                $("#gradingcolor6" + j.Id).removeClass("active-color5");
                $("#gradingcolor7" + j.Id).removeClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 60) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).addClass("active-color3");
                $("#gradingcolor5" + j.Id).addClass("active-color4");
                $("#gradingcolor6" + j.Id).addClass("active-color5");
                $("#gradingcolor7" + j.Id).removeClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 70) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).addClass("active-color3");
                $("#gradingcolor5" + j.Id).addClass("active-color4");
                $("#gradingcolor6" + j.Id).addClass("active-color5");
                $("#gradingcolor7" + j.Id).addClass("active-color6");
                $("#gradingcolor8" + j.Id).removeClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 80) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).addClass("active-color3");
                $("#gradingcolor5" + j.Id).addClass("active-color4");
                $("#gradingcolor6" + j.Id).addClass("active-color5");
                $("#gradingcolor7" + j.Id).addClass("active-color6");
                $("#gradingcolor8" + j.Id).addClass("active-color7");
                $("#gradingcolor9" + j.Id).removeClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 90) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).addClass("active-color3");
                $("#gradingcolor5" + j.Id).addClass("active-color4");
                $("#gradingcolor6" + j.Id).addClass("active-color5");
                $("#gradingcolor7" + j.Id).addClass("active-color6");
                $("#gradingcolor8" + j.Id).addClass("active-color7");
                $("#gradingcolor9" + j.Id).addClass("active-color8");
                $("#gradingcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 100) {
                $("#gradingcolor1" + j.Id).addClass("active-color");
                $("#gradingcolor2" + j.Id).addClass("active-color1");
                $("#gradingcolor3" + j.Id).addClass("active-color2");
                $("#gradingcolor4" + j.Id).addClass("active-color3");
                $("#gradingcolor5" + j.Id).addClass("active-color4");
                $("#gradingcolor6" + j.Id).addClass("active-color5");
                $("#gradingcolor7" + j.Id).addClass("active-color6");
                $("#gradingcolor8" + j.Id).addClass("active-color7");
                $("#gradingcolor9" + j.Id).addClass("active-color8");
                $("#gradingcolor10" + j.Id).addClass("active-color9");
              }
            });
          });
          this.state.Vesseldata.map((i) => {
            let _this = this;
            $(document).ready(function () {
              $(".vesselsliderDivClass" + i.Id).slider({
                orientation: "horizontal",
                range: "min",
                min: 0,
                max: 100,
                step: 1,
                value: 0,
                slide: function (event, ui) {
                  $("#vesselSliderInputId" + i.Id).val(ui.value);
                  _this.setVesselSliderValue(i.Id, ui.value);
                }
              });
              _this.setManagementSliderValue();
            });
          });
          this.state.Vesseldata.map((j) => {
            $(document).ready(function () {
              $("#vesselSliderInputId" + j.Id).val($(".vesselsliderDivClass" + j.Id).slider("value"));
              var value = $('#vesselSliderInputId' + j.Id).val();
              console.log(value)
              if (parseInt(value) === 0) {
                $("#vesselcolor1" + j.Id).removeClass("active-color");
                $("#vesselcolor2" + j.Id).removeClass("active-color1");
                $("#vesselcolor3" + j.Id).removeClass("active-color2");
                $("#vesselcolor4" + j.Id).removeClass("active-color3");
                $("#vesselcolor5" + j.Id).removeClass("active-color4");
                $("#vesselcolor6" + j.Id).removeClass("active-color5");
                $("#vesselcolor7" + j.Id).removeClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 10) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).removeClass("active-color1");
                $("#vesselcolor3" + j.Id).removeClass("active-color2");
                $("#vesselcolor4" + j.Id).removeClass("active-color3");
                $("#vesselcolor5" + j.Id).removeClass("active-color4");
                $("#vesselcolor6" + j.Id).removeClass("active-color5");
                $("#vesselcolor7" + j.Id).removeClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 20) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).removeClass("active-color2");
                $("#vesselcolor4" + j.Id).removeClass("active-color3");
                $("#vesselcolor5" + j.Id).removeClass("active-color4");
                $("#vesselcolor6" + j.Id).removeClass("active-color5");
                $("#vesselcolor7" + j.Id).removeClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 30) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).removeClass("active-color3");
                $("#vesselcolor5" + j.Id).removeClass("active-color4");
                $("#vesselcolor6" + j.Id).removeClass("active-color5");
                $("#vesselcolor7" + j.Id).removeClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 40) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).addClass("active-color3");
                $("#vesselcolor5" + j.Id).removeClass("active-color4");
                $("#vesselcolor6" + j.Id).removeClass("active-color5");
                $("#vesselcolor7" + j.Id).removeClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 50) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).addClass("active-color3");
                $("#vesselcolor5" + j.Id).addClass("active-color4");
                $("#vesselcolor6" + j.Id).removeClass("active-color5");
                $("#vesselcolor7" + j.Id).removeClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 60) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).addClass("active-color3");
                $("#vesselcolor5" + j.Id).addClass("active-color4")
                $("#vesselcolor6" + j.Id).addClass("active-color5");
                $("#vesselcolor7" + j.Id).removeClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 70) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).addClass("active-color3");
                $("#vesselcolor5" + j.Id).addClass("active-color4")
                $("#vesselcolor6" + j.Id).addClass("active-color5");
                $("#vesselcolor7" + j.Id).addClass("active-color6");
                $("#vesselcolor8" + j.Id).removeClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 80) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).addClass("active-color3");
                $("#vesselcolor5" + j.Id).addClass("active-color4")
                $("#vesselcolor6" + j.Id).addClass("active-color5");
                $("#vesselcolor7" + j.Id).addClass("active-color6")
                $("#vesselcolor8" + j.Id).addClass("active-color7");
                $("#vesselcolor9" + j.Id).removeClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 90) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).addClass("active-color3");
                $("#vesselcolor5" + j.Id).addClass("active-color4")
                $("#vesselcolor6" + j.Id).addClass("active-color5");
                $("#vesselcolor7" + j.Id).addClass("active-color6")
                $("#vesselcolor8" + j.Id).addClass("active-color7");
                $("#vesselcolor9" + j.Id).addClass("active-color8");
                $("#vesselcolor10" + j.Id).removeClass("active-color9");
              } else if (parseInt(value) <= 100) {
                $("#vesselcolor1" + j.Id).addClass("active-color");
                $("#vesselcolor2" + j.Id).addClass("active-color1");
                $("#vesselcolor3" + j.Id).addClass("active-color2");
                $("#vesselcolor4" + j.Id).addClass("active-color3");
                $("#vesselcolor5" + j.Id).addClass("active-color4")
                $("#vesselcolor6" + j.Id).addClass("active-color5");
                $("#vesselcolor7" + j.Id).addClass("active-color6")
                $("#vesselcolor8" + j.Id).addClass("active-color7");
                $("#vesselcolor9" + j.Id).addClass("active-color8");
                $("#vesselcolor10" + j.Id).addClass("active-color9");
              }
            });
          })
          console.log(this.state.conditionData, this.state.managementData)
          dispatch({ type: "SHOW_LOADER", data: false })
        } else {

        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");        
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });

        if (error?.response?.status === 401) {
        
        }
      });
  }

  AddCancel1 = () => {
    if (this.state.cancel == true) {
      window.$("#cancelpopup").modal("show");
    }
    else {
      this.props.dispatch({ type: "CANCEL", data: false });
      this.props.navigate(`/shiplist`)
    }
  }

  addGradingInfo = (condition, management) => {
    this.state.conditionData.ModifiedBy = "";
    this.state.managementData.ModifiedBy = "";
    this.state.managementData.CreatedBy = localStorage.getItem("UserRoles");
    this.state.conditionData.CreatedBy = localStorage.getItem("UserRoles");
    this.setState({});
    let apiUrl = API.AddEdit_Grading + "?id=0&id=0";
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        Condition: condition,
        Management: management
      },
    })
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data.length > 0) {
            this.state.managementData.Id = response.data[1];
            this.state.conditionData.Id = response.data[0];
            this.setState({})
          }
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
            //successAlert("Data saved successfully.");
            successToast();
        } else {

        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  }
  updateGradingInfo = (IdCon, IdMan, condition, management) => {
    this.state.conditionData.CreatedBy = "";
    this.state.managementData.CreatedBy = "";
    this.state.managementData.ModifiedBy = localStorage.getItem("UserRoles");
    this.state.conditionData.ModifiedBy = localStorage.getItem("UserRoles");
    this.setState({})
    let apiUrl = `${API.AddEdit_Grading}?id=${IdCon}&id=${IdMan}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        Condition: condition,
        Management: management
      },
    })
      .then((response) => {
       if (response?.status === 200) {
          this.props.dispatch({ type: "SHOW_LOADER", data: false })
           //successAlert("Data saved successfully.");
           successToast();
         }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });

  }
  Save = () => {
    this.state.conditionData.DesignAndConstruction = parseInt($("#redSliderInputId" + 1).val());
    this.state.conditionData.Hull = parseInt($("#redSliderInputId" + 2).val());
    this.state.conditionData.FocsleAndPoopDeck = parseInt($("#redSliderInputId" + 3).val());
    this.state.conditionData.MaindeckAndFittings = parseInt($("#redSliderInputId" + 4).val());
    this.state.conditionData.BallastTanksAndVoidSpaces = parseInt($("#redSliderInputId" + 5).val());
    this.state.conditionData.GalleyAndAccomodation = parseInt($("#redSliderInputId" + 6).val());
    this.state.conditionData.EngineRoom = parseInt($("#redSliderInputId" + 7).val());
    this.state.conditionData.FireAndSafety = parseInt($("#redSliderInputId" + 8).val());
    this.state.conditionData.LifesavingEquipment = parseInt($("#redSliderInputId" + 9).val());
    this.state.conditionData.SafeWorking = parseInt($("#redSliderInputId" + 10).val());
    this.state.conditionData.NavigationBridgeAndCommunication = parseInt($("#redSliderInputId" + 11).val());
    this.state.conditionData.PollutionControl = parseInt($("#redSliderInputId" + 12).val());
    this.state.conditionData.OnboardManagement = parseInt($("#redSliderInputId" + 13).val());
    this.state.conditionData.CargoSystems = parseInt($("#redSliderInputId" + 14).val());
    this.state.managementData.ForthcomingRegulatoryCompliance = parseInt($('#vesselSliderInputId' + 1).val());
    this.state.managementData.CrewWelfare = parseInt($('#vesselSliderInputId' + 2).val());
    this.state.managementData.CrewPerformance = parseInt($('#vesselSliderInputId' + 3).val());
    this.state.managementData.HseqSystems = parseInt($('#vesselSliderInputId' + 4).val());
    this.state.managementData.ManagementSystems = parseInt($('#vesselSliderInputId' + 5).val());
    this.state.managementData.ClassificationAndCertification = parseInt($('#vesselSliderInputId' + 6).val());
    this.state.managementData.VettingOrPscperformanceOrRecords = parseInt($('#vesselSliderInputId' + 7).val());
    this.setState({})
    if (this.state.conditionData.Id === 0 && this.state.managementData.Id === 0) {
      this.addGradingInfo(this.state.conditionData, this.state.managementData)
      this.setState({ cancel: false })
      this.props.dispatch({ type: "CANCEL", data: false });
    } else {
      this.props.dispatch({ type: "CANCEL", data: false });
      this.setState({ cancel: false })
      this.updateGradingInfo(this.state.conditionData.Id, this.state.managementData.Id, this.state.conditionData, this.state.managementData)
    }
  }
  render() {
    let { classes, menuToggle } = this.props;
    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 border-bottom mt-4 mob-topfixed">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"GRAD" + "1"}
                      className="  textNaviIcon"
                      primary="Inspection Tasks"
                    />
                    <NavigateNextIcon
                      id="GRAD"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Grading Data </h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
                ? "calc(100% - 240px)"
                : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      class="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td className="border-right text-center">
                    <button
                      className={`${classes.button}`}
                      onClick={() => {
                        this.Save();
                      }}
                    >
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                  </td>
                  <td className="text-center">
                    <button
                      className={`${classes.button} `}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <>
              <table className="dataTable" width="100%">
                <tbody>
                  <tr>
                    <td width="5%" className="border-right text-center">
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={this.AddCancel1}
                      ></i>
                    </td>
                    <td className="" width="95%">
                      <button
                        className={`${classes.button}`}
                        onClick={() => this.Save()}
                      >
                        <img src={Save} style={{ marginTop: "-4px" }}></img>
                        &nbsp;Save
                      </button>
                      <button
                        className={`${classes.button} pl-3`}
                        onClick={this.AddCancel1}
                      >
                        <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                        &nbsp;Cancel
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <div
            className="row"
            style={{ margin: this.state.isMobile ? "" : "5px" }}
          >
            <div className="row px-3">
              <div className="col-12 pt-2">
                {this.state.isMobile ? <></> : <h6>Grading Data</h6>}
              </div>
            </div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"
              }
            >


              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right"
                >
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="12">
                        <span className="spandoc-thead1">Vessel Condition</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.Gradingdata.map((x, index) => {
                      return (
                        <>
                          <tr className="border-top">
                            <td
                              width="40%"
                              className="border-right align-middle"
                              style={{ width: this.state.isMobile ? "28%" : "" }}
                            >
                              <span className="spandoc-thead">{x.title}</span>
                            </td>
                            <td
                              className="border-right"
                              id={`gradingcolor1${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor2${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor3${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor4${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor5${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor6${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor7${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor8${x.Id}`}
                            ></td>
                            <td

                              className="border-right"
                              id={`gradingcolor9${x.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`gradingcolor10${x.Id}`}
                            ></td>
                            <td
                              width="15%"
                              className="text-center align-middle"
                              style={{ width: window.innerWidth < 410 ? "20%" : this.state.isMobile ? "20%" : "" }}
                            >
                              <input
                                type="text"
                                id={`redSliderInputId${x.Id}`}
                                className="sliderInputClass"
                                min="0"
                                max="100"
                                readOnly
                              />
                              <br />
                              <div
                                id={`redSliderDivId${x.Id}`}
                                className={`sliderDivClass${x.Id} sliderstyle`}
                              ></div>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"
              }
            >
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right"
                >
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="12">
                        <span className="spandoc-thead">Vessel Management</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.Vesseldata.map((y, index) => {
                      return (
                        <>
                          <tr className="border-top">
                            <td
                              width="40%"
                              className="border-right align-middle"
                              style={{ width: this.state.isMobile ? "28%" : "" }}
                            >
                              <span className="spandoc-thead">{y.title}</span>
                            </td>
                            <td
                              className="border-right"
                              id={`vesselcolor1${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor2${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor3${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor4${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor5${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor6${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor7${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor8${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor9${y.Id}`}
                            ></td>
                            <td
                              className="border-right"
                              id={`vesselcolor10${y.Id}`}
                            ></td>
                            <td
                              width="15%"
                              className="text-center align-middle"
                              style={{ width: window.innerWidth < 410 ? "20%" : this.state.isMobile ? "20%" : "" }}
                            >
                              <input
                                type="text"
                                id={`vesselSliderInputId${y.Id}`}
                                className="vesselsliderInputClass"
                                readonly="readonly"
                              />
                              <br />
                              <div
                                id={`vesselSliderDivId${y.Id}`}
                                className={`vesselsliderDivClass${y.Id}  sliderstyle`}
                              ></div>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    settings: state.commonReducer.settings || [],
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditGD))
);
